const routes = [
    {
        path: '/teams',
        name: 'teams',
        component: () => import('@/pages/teams/List.vue'),
        meta: { breadCrumb: 'Teams', entity: 'editTeams' },
    },
]

export default routes
